module.exports = "<iframe\n  *ngIf=\"isYoutubeVideo === true\"\n  #videoIframe\n  id=\"youtube-iframe\"\n  [src]=\"safeVideoUrl\"\n  frameborder=\"0\"\n  allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\"\n  allowfullscreen\n>\n</iframe>\n\n<video\n  *ngIf=\"isYoutubeVideo === false\"\n  #videoTag\n  id=\"video-tag\"\n  [src]=\"safeVideoUrl\"\n  [controls]=\"true\"\n></video>\n"


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/video/video.component.html
// module id = ../../../../../src/app/components/video/video.component.html
// module chunks = main